import React, { useState, useEffect, useRef } from 'react'
import { MapContainer, TileLayer } from 'react-leaflet';
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import PinDropIcon from '@mui/icons-material/PinDrop';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import telephonecall from '../../../../Assets/telephonecall.png'
import PersonIcon from '@mui/icons-material/Person';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import { ChevronDown, ChevronUp } from 'lucide-react';
import BackpackOutlinedIcon from '@mui/icons-material/BackpackOutlined';
import { ClipLoader } from 'react-spinners';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import rightArrow from "../../../../Assets/navbar/right-arrow.svg";
import { keys } from '@mui/system';
import OLAMapsForDriverLocation from '../../../Customers/OLAMapsForDriverLocation';
import mediumCraneImage from '../../../../Assets/crane/mediumCrane.jpg'
import mediumRecoveryVanImage from '../../../../Assets/crane/mediumRecoveryVan.jpg'
import mediumFlatbedImage from '../../../../Assets/crane/mediumFlatbed.jpg'
import frontLeft from '../../../../Assets/crane/front-left.jpg'
import { FiDownload } from 'react-icons/fi'

const FirstCardPage = (props) => {

    let driverChangedOnSelection = true

    console.log('props in first card page', props)

    function setDriverlatitudeAndLongitude(driverLatitude, driverLongitude) {
        props.accidentData.driverLatitude = driverLatitude;
        props.accidentData.driverLongitude = driverLongitude;
    }  

    function setDriverChangedOnSelection(value) {
        driverChangedOnSelection = value;
    }

    //console.log('proisadasfdafdasfd', props)
    //console.log('props.accidentData?.dropLatitude', props?.accidentData?.dropLatitude)
    //console.log('props.accidentData?.dropLongitude', props.accidentData?.dropLongitude)
    //console.log('props.accidentData?.pickupLongitude', props.accidentData?.pickupLongitude)
    //console.log('props.accidentData?.pickupLatitude', props.accidentData?.pickupLatitude)

    const [type, setType] = useState(
        props?.accidentData?.vendorType
            ?.replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
            ?.replace(/^./, (char) => char.toUpperCase()) // Capitalize first letter
    );

    //console.log('props?.AccidentVehicleCod', props?.accidentData?.AccidentVehicleCode)
    const [isOpenDistance, setIsOpenDistance] = useState(false)
    const [isOpenDuration, setIsOpenDuration] = useState(false)
    const [gotData, setGotData] = useState(false)

    const [showFull, setShowFull] = useState(false);
    const [showFull2, setShowFull2] = useState(false);


    const [isModalOpen, setIsModalOpen] = useState(false)
    const [timeLeft, setTimeLeft] = useState(0); //assignedOn

    const containerRef = useRef(null);
    //console.log('rops?.accidentData?', props?.accidentData)
    //console.log('rprops.accidentData?.VendorDriverNumber', props.accidentData?.VendorDriverNumber)

    //console.log('props.accidentData?.dropLatitude', props.accidentData?.dropLatitude)

    const [isTall, setIsTall] = useState(false);

    const vehicleOptions = (props.accidentData?.VendorDriverNumber || []).map((vehicleDetails, idx) => {
        const distance = props.accidentData?.fromVendorLocationToPickDistance?.[idx] ?? 'N/A';
        return {
            label: `${vehicleDetails.vehicleNo} - ${distance} km`,
            value: vehicleDetails.vehicleNo,
        };
    });
    //console.log('vehicleDetails', props.accidentData?.VendorDriverNumber)
    const driverOptions = (props.accidentData?.VendorDriverNumber || []).map((vehicleDetails, idx) => {
        return {
            label: `${vehicleDetails.phone} ${vehicleDetails.driverName}`,
            value: vehicleDetails.phone,
            driverlat: vehicleDetails.latitude,
            driverlng: vehicleDetails.longitude,
        };
    });
    //console.log('gotdata12312', props)
    //console.log('driverOptions', driverOptions)


    useEffect(() => {
        if (props?.accidentData) {
            //console.log('gotdata123124', props?.accidentData)
            setGotData(true)
        }
    }, [props])
    
   useEffect(() => {
        if (props.onTimeUpdate) {      
            props.onTimeUpdate(timeLeft);
        }
    }, [timeLeft]);


    useEffect(() => {
        const checkHeight = () => {
            if (containerRef.current) {
                const height = containerRef.current.clientHeight;
                setIsTall(height > 380);
            }
        };

        checkHeight();
        window.addEventListener('resize', checkHeight);
        return () => window.removeEventListener('resize', checkHeight);
    }, []);

    useEffect(() => {
        const assignedOn = props?.accidentData?.assignedOn;
        if (!assignedOn) return; // Wait until data is ready

        const caseAssignedAt = new Date(assignedOn).getTime();
        const now = new Date().getTime();
        const timeElapsed = Math.floor((now - caseAssignedAt) / 1000); // in seconds
        const totalDuration = 9000; // 30 seconds countdown
        const initialTimeLeft = totalDuration - timeElapsed;
        setTimeLeft(initialTimeLeft > 0 ? initialTimeLeft : 0);

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    props.setFirstPage(false);
                    props.setIsViewImage(false)
                    props.setIsRejected(false)
                    props.setResponseVehicle(props?.accidentData?.AccidentVehicleCode);

                    const firstVehicleNo = props.accidentData?.VendorDriverNumber?.[0]?.vehicleNo;
                    const firstDriverNo = [props.accidentData?.VendorDriverNumber?.[0]?.phone];
                    //console.log('firstVehicleNo', firstVehicleNo)
                    //console.log('firstDriverNo', firstDriverNo)

                    //console.log('firstDriverNo', props.accidentData?.VendorDriverNumber)

                    if (!props.responseVehicle && firstVehicleNo) {
                        props.setSelectedVendorVehicle(firstVehicleNo);
                        props.setSelectedVendorDriver(firstDriverNo);

                    }

                    props.setStopClockTimer(true)
                    // props.stopTimer(); // Close the page when the timer reaches 0
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(timer); // Cleanup the interval on component unmount
    }, [props?.accidentData?.assignedOn]);

    useEffect(() => {
        if (props.selectedIndex === null && vehicleOptions.length > 0 && driverOptions.length > 0) {
            props.setSelectedIndex(0);
            props.setSelectedVendorVehicle(vehicleOptions[0].value);
            props.setSelectedVendorDriver({
                0: driverOptions[0]?.value || '',
            });
        }

    }, []);
    const radius = 50 / 2; // Adjusted for 20px total 50
    const stroke = 2; // Adjusted stroke width
    const normalizedRadius = radius - stroke * 0.5;
    const circumference = 2 * Math.PI * normalizedRadius;
    const strokeDashoffset = circumference - (timeLeft / 9000) * circumference;

    // Convert seconds to MM:SS format
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        // return `${m}:${s.toString().padStart(2, '0')}`;
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };
    const toTitleCase = (input) => {
        return input
            .split(" ")
            .map(word =>
                word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : ""
            )
            .join(" ");
    }


     useEffect(() => {
        if (props.sendDataToParent) {
            props.sendDataToParent(props?.accidentData?.assignedOn);
        }
    }, [timeLeft]);

    return (
        <div className='relative  font-satoshi'>
            {gotData && (<div className='h-1/2 relative max-w-[90vw]'>
                {!isOpenDistance && (
                    // <MapContainer
                    //     zoom={13}
                    //     center={[19.0760, 72.8777]}
                    //     // className='rounded-t-[10%]'
                    //     style={{ width: '100%', height: '40vh' }}
                    // >
                    //     <TileLayer
                    //         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    //         attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    //     />
                    // </MapContainer>
                    <OLAMapsForDriverLocation
                        dropLatitude={props.accidentData?.dropLatitude}
                        dropLongitude={props.accidentData?.dropLongitude}
                        pickupLatitude={props.accidentData?.pickupLatitude}
                        pickupLongitude={props.accidentData?.pickupLongitude}
                        driverLatitude={props.accidentData?.driverLatitude}
                        driverLongitude={props.accidentData?.driverLongitude}
                        allowDriverProceed={props.accidentData?.allowDriverProceed}
                        driverChangedOnSelection={driverChangedOnSelection}
                        adjustWidth={true}
                    />
                )}

                <div className=' bg-[#2d4f5d]'>

                    {isOpenDistance && (

                        <>
                            <div className="relative font-satoshi top-0 left-0 w-full bg-[#697c9b] text-white transition-all duration-300 h-[50%] z-50">
                                <div className="p-4  bg-white text-black">
                                    <h2 className="text-sm font-semibold mb-2">Trip Details</h2>

                                    {/* Vendor Current Location */}
                                    <div className="flex items-center space-x-4 mb-1">
                                        <MyLocationIcon className="text-blue-400 h-4" />
                                        <div>
                                            <h4 className="text-sm font-semibold">Vendor's Current Location</h4>
                                            <p className="text-xs">(Your Location)</p>
                                        </div>
                                    </div>

                                    {/* Line and Distance/Duration between Vendor and Pickup */}
                                    <div className="relative flex items-center mb-1 ml-[6px]">
                                        <div className="w-[2px] h-12 bg-gray-300 ml-[6px]"></div>
                                        <div className="ml-4 flex flex-col justify-center">
                                            <p className="text-xs font-semibold">{props?.accidentData?.fromVendorLocationToPickDuration}</p>
                                            <p className="text-xs font-semibold">
                                                {props?.accidentData?.fromVendorLocationToPickDistance
                                                    ? `${parseFloat(props?.accidentData?.fromVendorLocationToPickDistance).toFixed(2)} Km`
                                                    : 'N/A'}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Pickup Location */}
                                    <div className="flex items-center space-x-4 mb-1">
                                        <PinDropIcon className="text-green-400 h-6" />
                                        <div>
                                            <h4 className="text-sm font-semibold">Pickup Location</h4>
                                            <p
                                                className={`text-xs cursor-pointer transition-all duration-200 ${showFull
                                                    ? 'whitespace-normal overflow-visible text-clip'
                                                    : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                    }`}
                                                onClick={() => setShowFull(!showFull)}
                                                title={props?.accidentData?.pickupLocation}
                                            >
                                                {toTitleCase(props?.accidentData?.pickupLocation)}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Line and Distance/Duration between Pickup and Drop */}
                                    <div className="relative flex items-center mb-1 ml-[6px]">
                                        <div className="w-[2px] h-12 bg-gray-300 ml-[6px]"></div>
                                        <div className="ml-4 flex flex-col justify-center">
                                            <p className="text-xs font-semibold">{props?.accidentData?.fromPickToDropDuration}</p>
                                            <p className="text-xs font-semibold">
                                                {props?.accidentData?.fromPickToDropDistance
                                                    ? `${parseFloat(props?.accidentData?.fromPickToDropDistance).toFixed(2)} Km`
                                                    : 'N/A'}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Drop Location */}
                                    <div className="flex items-center space-x-4">
                                        <PinDropIcon className="text-red-400 h-6" />
                                        <div>
                                            <h4 className="text-sm font-semibold">Drop Location</h4>
                                            <p
                                                className={`text-xs cursor-pointer transition-all duration-200 ${showFull2
                                                    ? 'whitespace-normal overflow-visible text-clip'
                                                    : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                    }`}
                                                onClick={() => setShowFull2(!showFull2)}
                                                title={props?.accidentData?.dropLocation}
                                            >
                                                {toTitleCase(props?.accidentData?.dropLocation)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>

                    )}



                    <div className="bg-white z-10 relative">
                        <div className="px-1 py-1">
                            <div className="flex flex-col px-[1rem]">
                                <div
                                    className="flex justify-between items-center pr-3 cursor-pointer"
                                    onClick={() => setIsOpenDistance(!isOpenDistance)}
                                >
                                    <div className="flex items-center space-x-4 top-0 h-2">
                                        <p className="text-black text-sm font-semibold mt-1">Distance </p>
                                        <div className="flex justify-center items-center" style={{ height: 30, width: 100 }}>
                                            <div className="relative w-full h-5 rounded-full bg-[#2c2f3b]/20 overflow-hidden">

                                                {/* Progress fill */}
                                                <div
                                                    className="absolute top-0 left-0 h-full rounded-full bg-[#EFF9FD] transition-all duration-300"
                                                    style={{
                                                        width: `${(timeLeft / 9000) * 100}%`,
                                                    }}
                                                ></div>

                                                {/* Time text centered inside */}
                                                <div className="absolute inset-0 flex items-center justify-center">
                                                    <span className="text-[10px] font-semibold text-red-500 animate-pulse">
                                                        {formatTime(timeLeft)}
                                                    </span>
                                                </div>

                                            </div>
                                        </div>



                                    </div>
                                    <div className="flex items-center mt-1">
                                        <div className="text-xs text-black font-semibold px-1 py-1 m-1 rounded-xl">
                                            {Number(props?.accidentData?.totalDistance || 0).toFixed(1)} Km

                                        </div>
                                        {isOpenDistance ? (
                                            <ChevronUp className="text-black h-6 p-1 bg-gray-200 rounded-full" />
                                        ) : (
                                            <ChevronDown className="text-black h-6 p-1  bg-gray-200 rounded-full" />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='bg-white h-full p-2'>
                    <div style={{ boxShadow: '1px 1px 7px 0px' }} className='bg-[#f9f9f9] rounded-xl flex justify-between m-1 mb-3'>
                        <div className='px-2 py-2 flex-col'>
                            <div className='flex justify-center items-center text-center'>
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/front-left.jpg' alt='truck image' className=' h-[2.5rem] w-[3rem]' />
                                <h4 className='text-[1rem] font-semibold mt-[0.3rem] pl-[1rem]'>{props?.accidentData?.reg} </h4>
                            </div>
                            <div className='flex flex-col'>
                                {/* <p className='text-xs font-semibold mt-2 text-green-9000'>Nature Of Breakdown : Accident </p> */}
                                <p className='text-xs font-semibold'>{type} Service Required</p>
                                {/* <div className='bg-yellow-500 rounded-xl p-1 mt-1'>
                                    <p className='font-xs font-semibold px-2'>4.5</p>
                                </div> */}
                            </div>
                        </div>
                        {/* <img className='h-20 w-20 p-2' src="https://toppng.com/uploads/preview/crane-png-indo-power-crane-11563243373unjn5iufbu.png" alt="crane" /> */}
                        <div className="p-1 rounded-xl border-4 border-blue-500 flex flex-col items-center justify-center">
                            {Object.keys(props.images).length > 0 && (
                                <img
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setIsModalOpen(true)}
                                    className="h-20 w-20 p-2 rounded-[20%]"
                                    src={props.images[Object.keys(props.images)[0]]}
                                    alt="crane"
                                />
                            )}
                            <p className="text-black text-xs">View Images</p>
                        </div>
                    </div>
                    {!props.isRejected && (<div>
                        <div className="flex gap-1 pb-3">
                            {/* <label htmlFor="vendorVehicleDropdown" className="text-md font-bold mt-2 mb-1">
                                Select Vehicle
                            </label> */}
                            {/* <select
                                id="vendorVehicleDropdown"
                                style={{ border: '2px solid black' }}
                                className=" font-satoshi w-full h-[35px] bg-gray-100 border border-gray-300 text-gray-700 text-sm rounded-lg px-2 focus:outline-none focus:ring-2 focus:ring-[#21A6E9] transition"
                                // className="text-xs p-2 border rounded"
                                value={props.selectedVendorVehicle}
                                onChange={(e) => props.setSelectedVendorVehicle(e.target.value)}
                            >
                                <option value="" >
                                    Select Vehicle
                                </option>
                                {vehicleOptions.map(({ label, value }) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </select>
                            <select
                                id="vendorDriverDropdown"
                                style={{ border: '2px solid black' }}
                                className="font-satoshi  w-full h-[35px] bg-gray-100 border border-gray-300 text-gray-700 text-sm rounded-lg px-2 focus:outline-none focus:ring-2 focus:ring-[#21A6E9] transition"
                                // className="text-xs p-2 border rounded"
                                value={props.selectedVendorDriver}
                                onChange={(e) => props.setSelectedVendorDriver(e.target.value)}
                            >
                                <option value={null} >
                                    Select Driver
                                </option>
                                {driverOptions.map(({ label, value }) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </select> */}
                            <hr />
                            <div className="flex flex-col w-full">
                                {vehicleOptions.map((vehicle, index) => {
                                    const isSelected = props.selectedIndex === index;
                                    const isDriverEditable = props.editableDriverIndex === index;
                                    const selectedDriverValue = props.selectedVendorDriver?.[0] || '';
                                    const selectedDriver = driverOptions.find(d => d.value === selectedDriverValue);
                                    const defaultDriver = driverOptions[index] || {};

                                    return (
                                        <div
                                            key={vehicle.value}
                                            style={{
                                                boxShadow: props.selectedIndex !== null && isSelected ? '2px 0px 2px' : '',
                                                // borderTop: isSelected ? '3px solid rgb(11, 150, 237)' : '1px solid transparent',
                                                border: isSelected ? '2px solid black' : '1px solid transparent',
                                                // backgroundColor: isSelected ? 'transparent' : '#f9fafb',
                                                opacity: props.selectedIndex !== null && !isSelected ? 0.9 : 1,
                                                cursor: props.selectedIndex === null || isSelected ? 'pointer' : 'not-allowed',
                                                // pointerEvents: props.selectedIndex === null || isSelected ? 'auto' : 'none',
                                                pointerEvents: props.selectedIndex
                                            }}
                                            className="flex mt-1 gap-1 rounded-xl justify-around items-center"
                                            onClick={() => {
                                                if (!isSelected) {
                                                    // Select this vehicle and driver
                                                    props.setSelectedIndex(index);
                                                    props.setSelectedVendorVehicle(vehicle.value);
                                                    props.setSelectedVendorDriver([driverOptions[index]?.value || '']);
                                                    setDriverlatitudeAndLongitude(driverOptions[index]?.driverlat, driverOptions[index]?.driverlng);
                                                    props.setEditableDriverIndex(null);
                                                    setDriverChangedOnSelection(true);
                                                }
                                            }}
                                        >
                                            <img
                                                src={type === 'Recovery Van' ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumRecoveryVan.jpg' : 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumCrane.jpg'}
                                                className="h-[2.5rem] w-[4rem] pl-[1rem]"
                                                alt="service provider"
                                            />

                                            <label htmlFor={`vehicle-${index}`} className="text-xs mt-2 mb-1 w-[130px]">
                                                <div className="flex flex-col items-center">
                                                    <p className="text-xs font-semibold mt-2">{vehicle.value}</p>
                                                    <p className="text-xs mt-1 mb-1">{vehicle.label.split('-')[1]}</p>
                                                </div>
                                            </label>

                                            <div className="flex flex-col pr-2">
                                                {isDriverEditable && (<select
                                                    id={`driver-${index}`}
                                                    className="font-satoshi w-full h-[35px] text-xs rounded-lg px-2 focus:outline-none focus:ring-2 focus:ring-[#21A6E9] transition"
                                                    value={props.selectedVendorDriver?.[0]}
                                                    onChange={(e) => {
                                                        props.setSelectedVendorDriver([e.target.value]);
                                                    }}

                                                >
                                                    <option value="">Select Driver</option>
                                                    {driverOptions.map(({ label, value }) => (
                                                        <option key={value} value={value}>
                                                            {label}
                                                        </option>
                                                    ))}
                                                </select>)}

                                                {/* Show driver number even when not editable */}
                                                {!isDriverEditable && (
                                                    <p className="text-[12px] text-gray-600 mt-1">
                                                        {[driverOptions[index]?.value || '']}
                                                    </p>
                                                )}

                                                {isSelected && driverOptions.length > 1 && (
                                                    <p
                                                        className="underline text-[11px] text-green-800 text-end cursor-pointer"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            props.setEditableDriverIndex(index);
                                                        }}
                                                    >
                                                        Change Driver
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>




                        </div>
                        <div className='bg-white flex justify-between m-1' style={{ borderTop: '1px solid gray' }}>
                            <div className='px-2 py-1 flex-col'>
                                <div class='flex'>
                                    <MyLocationIcon className='m-1 mt-2' />
                                    <div className='px-2 py-2 flex-col'>
                                        <p
                                            className={`text-xs cursor-pointer transition-all duration-200 ${showFull
                                                ? 'whitespace-normal overflow-visible text-clip'
                                                : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                }`}
                                            onClick={() => setShowFull(!showFull)}
                                            title={props?.accidentData?.pickupLocation}// Tooltip on hover
                                        >
                                            {props?.accidentData?.pickupLocation}
                                        </p>
                                        <p className='text-xs font-semibold truncate'>Vehicle Location</p>
                                    </div>
                                </div>
                                <div class='flex'>
                                    <PinDropIcon className='m-1 mt-2' />
                                    <div className='px-1 py-1 flex-col'>
                                        <p
                                            className={`text-xs cursor-pointer transition-all duration-200 ${showFull2
                                                ? 'whitespace-normal overflow-visible text-clip'
                                                : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                }`}
                                            onClick={() => setShowFull2(!showFull2)}
                                            title={props?.accidentData?.dropLocation}// Tooltip on hover
                                        >
                                            {props?.accidentData?.dropLocation}
                                        </p>
                                        <h4 className='text-xs font-semibold truncate'>Drop Location </h4>
                                    </div>
                                </div>



                                {Boolean(props?.accidentData?.isMaterialLoaded) && (
                                    <div class='flex'>
                                        <BackpackOutlinedIcon className='m-1 mt-2' />
                                        <div className='px-1 py-1 flex-col'>
                                            {/* <p className='text-xs font-base'>{props?.accidentData.quantity}</p> */}
                                            <h4 className='text-xs font-semibold mt-2'>{props?.accidentData?.quantity} Loaded (in tons) </h4>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='px-1 py-4'>
                                <h2 className='font-semibold text-[1rem] flex'>₹ {props?.accidentData?.nonGSTCharge}</h2>
                            </div>
                            {/* <img className='h-20 w-20 p-2' src="https://toppng.com/uploads/preview/crane-png-indo-power-crane-11563243373unjn5iufbu.png" alt="crane" /> */}
                        </div>




                        <div>
                            <div className='bg-white flex justify-between items-center' style={{ borderTop: '1px solid gray' }}>
                                {/* Accept & Reject Buttons */}
                                {/* <div className='flex md:flex-col gap-2 p-2'> */}
                                <div
                                    ref={containerRef}
                                    className={`flex gap-2 p-2 ${isTall ? 'flex-col' : 'flex-row'}`}
                                >
                                    <button
                                        type="button"
                                        // disabled={props.selectedVendorVehicle === "" || props.selectedVendorDriver == null}
                                        className={`flex items-center justify-center gap-2 text-white text-xs font-semibold py-2 px-4 rounded-xl transition-all w-full
    ${(props.selectedVendorVehicle === "" || props.selectedVendorDriver == null)
                                                ? 'bg-[#21A6E9] cursor-not-allowed'
                                                : 'bg-[#21A6E9] hover:bg-[#1c94d1]'}`}
                                        onClick={() => {
                                            props.setFirstPage(false);
                                            props.setIsViewImage(false);
                                            props.setIsRejected(false);
                                            props.setVendorDecision('accept');
                                            props.setResponseVehicle(props?.accidentData?.AccidentVehicleCode);

                                            // Set default vehicle if not selected
                                            if (!props.selectedVendorVehicle) {
                                                props.setSelectedVendorVehicle(props?.accidentData?.VendorDriverNumber?.[0]?.vehicleNo || '');
                                            }

                                            // Set default driver if not selected
                                            if (
                                                !props.selectedVendorDriver ||
                                                Object.keys(props.selectedVendorDriver).length === 0
                                            ) {
                                                props.setSelectedVendorDriver({
                                                    0: props?.accidentData?.VendorDriverNumber?.[0]?.phone || '',
                                                });
                                            }
                                        }}

                                    >
                                        <p>Accept</p>
                                    </button>

                                    <button
                                        type="button"
                                        // disabled={props.selectedVendorVehicle !== "" && props.selectedVendorDriver !== null}
                                        className={`flex items-center justify-center gap-2 text-white text-xs font-semibold py-2 px-4 rounded-xl transition-all w-full
                                                    ${(props.selectedVendorVehicle !== "" && props.selectedVendorDriver !== null)
                                                ? 'bg-[#a1bcca] cursor-not-allowed'
                                                : 'bg-[#EE3840] hover:bg-[#d32f2f]'}`}
                                        onClick={() => {
                                            props.setFirstPage(false);
                                            props.setIsAccepted(false);
                                            props.setIsViewImage(false);
                                            props.setIsRejected(true);
                                            props.setVendorDecision('reject');
                                            props.setResponseVehicle(props?.accidentData?.AccidentVehicleCode);

                                            if (!props.selectedVendorVehicle) {
                                                props.setSelectedVendorVehicle(props?.accidentData?.VendorDriverNumber?.[0]?.vehicleNo || '');
                                            }

                                            if (!props.selectedVendorDriver || Object.keys(props.selectedVendorDriver).length === 0) {
                                                props.setSelectedVendorDriver({
                                                    0: props?.accidentData?.VendorDriverNumber?.[0]?.phone || '',
                                                });
                                            }
                                        }}

                                    >
                                        <p>Reject</p>
                                    </button>

                                </div>

                                {/* Call Section */}
                                <div
                                    onClick={() => (window.location.href = 'tel: +91 7800 78 4700')}
                                    className='flex flex-col items-center justify-center px-2 py-2'
                                >
                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/telephonecall.png' className='h-[30px] w-[30px]' alt="call for help" />
                                    {/* <p className='text-black font-semibold text-xs text-center'>call for help</p> */}
                                </div>
                            </div>

                        </div>
                    </div>)}

                    {/* {props.isRejected && (
                        <div style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent background
                            zIndex: 1001,
                            display: "flex",
                            alignItems: "flex-end", // positions the container at the bottom
                            justifyContent: "center",
                            animation: "slideUp 0.5s ease-out",
                        }}>
                            <div className="image-container" style={{ background: "rgb(245 245 245 / 78%)" }}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <h1 style={{ textAlign: "center", fontWeight: "bold", fontSize: "15px", border: "4px solid black", borderImage: 'linear-gradient(to bottom, white 10%, black 90%) 1', borderRadius: "20px", margin: "20px 50px 0px 30px", padding: "5px", flex: 1 }}>Reason For Decline</h1>
                                    <div onClick={closeRejected}>
                                        <CloseIcon style={{ marginRight: '20px', cursor: 'pointer' }} />
                                    </div>
                                </div>
                                <hr />

                                <div style={{ margin: "10px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                    {reasons.map((reason) => (
                                        <button
                                            key={reason}
                                            onClick={() => handleSelectReason(reason)}
                                            style={{
                                                fontSize: '14px',
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                padding: "10px",
                                                borderRadius: "20px",
                                                backgroundColor: selectedReasons.includes(reason) ? "yellow" : "white",
                                                border: "1px solid black",
                                                cursor: "pointer",
                                                boxShadow: selectedReasons.includes(reason) ? "0 4px 8px rgba(0,0,0,1.2)" : "0 3px 6px rgba(0, 0, 0, 0.5)"
                                            }}
                                        >
                                            {reason}
                                        </button>
                                    ))}
                                </div>


                                <label className="form-field" style={{ color: '#3f3c00', marginTop: '20px', fontSize: "14px" }}>
                                    <p style={{ textAlign: "left" }}> Other Reason  : </p>
                                    <textarea
                                        style={{ margin: "10px 10px 20px 0px", width: "280px" }} className="form-control" name="otherReason" value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                                </label>

                                {errorMessage && <div style={{ color: "red", margin: "10px 10px 20px 10px", marginBottom: "10px" }}>{errorMessage}</div>}


                                <div>
                                    {isLoading && (
                                        <div style={{ marginTop: '10px', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                            <ClipLoader color="black" loading={isLoading} />
                                            <div style={{ marginTop: '10px', color: 'black' }}> Please Wait...</div>
                                        </div>
                                    )}
                                    <p type="submit"
                                        style={{
                                            fontSize: '11px',
                                            margin: "5px",
                                            background: "#8f4325",
                                            padding: "10px",
                                            border: '1px solid blue',
                                            textAlign: 'center',
                                            borderRadius: '30px',
                                            fontWeight: "bold",
                                            color: "white",
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: "center",
                                            position: "relative",
                                        }}
                                        disabled={isLoading}
                                        onClick={() => { props.setVendorDecision('reject'); props.handleSubmit() }}                                    >
                                        < NotInterestedIcon style={{
                                            position: 'absolute',
                                            left: "90px"
                                        }} />Reject Case
                                    </p>
                                </div>
                            </div>
                        </div>
                    )} */}
                    <div className="hidden flex justify-between gap-4">
                        <button
                            // onClick={prevStep}
                            className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-6 rounded-full transition-all w-full"
                        >
                            Back
                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                        </button>

                        <button
                            // onClick={nextStep}

                            // disabled={selection !== true}
                            className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-6 rounded-full transition-all w-full ${true
                                ? "bg-[#21A6E9] hover:bg-[#1e94d6]"
                                : "bg-[#a7dbf5] cursor-not-allowed"
                                }`}
                        >
                            Continue
                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px]" />
                        </button>
                    </div>

                </div>


                <ShowImagesModal
                    isOpen={isModalOpen}
                    images={props.images}
                    onClose={() => setIsModalOpen(false)}
                />

            </div>)}


        </div>
    )
}
export default FirstCardPage;



function ShowImagesModal({ isOpen, onClose, images }) {
    if (!isOpen) return null;

    let clickTimer = null;

    const handleImageClick = (url) => {
        if (clickTimer) {
            clearTimeout(clickTimer);
            clickTimer = null;
            handleDownload(url);
        } else {
            clickTimer = setTimeout(() => {
                clickTimer = null;
            }, 300);
        }
    };

const handleDownload = (url) => {
  try {
  const s3Key = new URL(url).pathname.substring(1);
    const downloadUrl = `${process.env.REACT_APP_BACKEND_URL}/api/downloadVehicleImage?key=${encodeURIComponent(s3Key)}`;

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = ""; // lets browser decide the filename
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    alert("Download failed.");
    console.error(err);
  }
};

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] px-2" style={{ pointerEvents: 'auto' }}>
            <div className="bg-white rounded-[24px] shadow-xl w-full max-w-[520px] h-[70vh] pt-3 md:p-6 relative animate-fadeIn flex flex-col">

                {/* Header with Close button on right */}
                <div className="flex items-center justify-between px-4 mb-1"
                >
                    <h6 className="text-[22px] md:text-[26px] font-semibold text-gray-800 font-satoshi">
                        Vehicle Images
                    </h6>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-800 text-[18px] font-semibold"
                        title="Close"
                    >
                        ✕
                    </button>
                </div>

                {/* Scrollable Image List */}
                <div className="flex-1 overflow-y-auto px-4 py-2 space-y-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
                    {Object.entries(images).map(([label, url], index) => (
                        <div
                            className="row text-center justify-content-center py-2 rounded-xl"
                            style={{ border: "3px solid grey", }}
                        >
                            <div key={index} className="flex flex-col items-center group relative" >
                                <div className="relative w-full max-w-[440px]">
                                    <img
                                        src={url}
                                        alt={label}
                                        className="w-full h-64 object-cover rounded-xl shadow-md scale-105 transition-transform duration-300"
                                        onError={(e) => (e.target.src = '/fallback-image.jpg')}
                                        onClick={() => handleImageClick(url)}
                                        style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                                    />
                                    <button
                                        onClick={() => handleDownload(url, label)}
                                        className="absolute top-2 right-2 bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 hidden group-hover:block transition-opacity"
                                        title="Download"
                                    >
                                        <FiDownload className="text-gray-700 text-lg" />
                                    </button>
                                </div>
                                <p className="text-sm mt-2 font-medium text-gray-600 text-center">{label}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Optional full-width close at bottom */}
                {/* <div className="my-4 px-4">
                    <button
                        onClick={onClose}
                        className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-6 rounded-full w-full bg-[#21A6E9]"
                    >
                        Close
                        <img src={rightArrow} alt="Close" className="h-[24px] w-[24px]" />
                    </button>
                </div> */}

            </div>
        </div>
    );
}